export default class Forms {
	constructor()
	{
		let isAfterAJAX = false;

		// REPORT DOWNLOADS FROM SELECT FIELD
		const send = XMLHttpRequest.prototype.send
		XMLHttpRequest.prototype.send = function() {
			this.addEventListener('load', function() {
				let isAfterAJAX = true;
				if(isAfterAJAX === true) {
					setTimeout(() => {
						this.reportDownload = document.querySelectorAll("[data-download]");
						this.reportDownload && this.reportDownload.forEach((button) => {
							button.addEventListener("click", (event) => {
								event.preventDefault();

								let link = document.querySelector('select[data-download-options="' + button.getAttribute('data-download-id') + '"]');

								this.sendFileDownloadvent(link.value, button)

								window.open(link.value);
							})
						});
					}, "100");
				}
			})
			return send.apply(this, arguments)
		}

		if(isAfterAJAX === false) {
			this.reportDownload = document.querySelectorAll("[data-download]");
			this.reportDownload && this.reportDownload.forEach((button) => {
				button.addEventListener("click", (event) => {
					event.preventDefault();
					let link = document.querySelector('select[data-download-options="' + button.getAttribute('data-download-id') + '"]');

					this.sendFileDownloadvent(link.value, button)

					window.open(link.value);
				})
			});
		}

		document.querySelectorAll(".posts-form-mobile-trigger").forEach((filter) => {

			filter.addEventListener("click", (event) => {
				const filterBy = filter.dataset.filter;
				const parentElement = filter.closest('.filter-group');

				if (filterBy && parentElement) {
					const filterMenu = parentElement.querySelector(`.filter-mobile-toggle[data-filter="${filterBy}"]`);
					if(filterMenu) {
						if( filter.getAttribute('aria-expanded') === "true" ){
							// IF FILTER IS ALREADY OPEN, SIMPLY TOGGLE OFF
							filterMenu.classList.toggle("filter-mobile-toggle--open");

							filter.setAttribute('aria-expanded', false)
						} else {
							const openFilters = document.querySelectorAll(".filter-mobile-toggle--open");
							const openSelectors = document.querySelectorAll('.posts-form-mobile-trigger[aria-expanded="true"]');

							// IF FILTER IS NOT ALREADY OPEN HIDE ALL OTHERS
							openSelectors.forEach((openSelector) => {
								openSelector.ariaExpanded = false;
							});

							openFilters.forEach((openFilter) => {
								openFilter.classList.remove("filter-mobile-toggle--open");
							});

							filter.setAttribute('aria-expanded', true)

							filterMenu.classList.toggle("filter-mobile-toggle--open");

						}
					}
				}

			});

		});


		this.selectInputs = document.querySelectorAll(".ginput_container_select select");
		if(this.selectInputs.length) {
			this.selectInputs && this.selectInputs.forEach((selectInput) => {
				selectInput.addEventListener("change", (event) => {
					selectInput.parentElement.previousElementSibling.style.display = 'none';
				});
			});
		}
	}

	sendFileDownloadvent(fullPath, button) {
		if (fullPath) {
			gtag('event', 'file_download_button_click', {
				'file_extension': fullPath.split('.').pop(),
				'file_name': fullPath.replace(/^.*[\\/]/, ''),
				'link_classes': button.classList.value,
				'link_id': button.id,
				'link_text': button.textContent.trim(),
				'link_url': fullPath
			});
		}
	}
}
